import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import "swiper/css"
import { Autoplay, Pagination } from "swiper/modules"

Swiper.use([Autoplay, Pagination])

export default class extends Controller {
  static targets = ["container", "progressbar"]

  connect() {
    this.swiper = new Swiper(this.containerTarget, {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: ".swiper-pagination",
      },
    })
  }
}
